import type { UseMutationResult } from '@tanstack/react-query';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useContext } from 'react';

import { ApplicationContext } from '~/shared/context/context';
import type { Pathname } from '~/shared/http-fetcher/http-fetcher';

export type UseAddFeaturedLearningOpportunityMutationResult = UseMutationResult<void, Error, ReadonlyArray<string>>;

export const useAddFeaturedLearningOpportunityMutation = (
    id: string,
): UseAddFeaturedLearningOpportunityMutationResult => {
    const { cobrainerApiFetcher } = useContext(ApplicationContext);
    const queryClient = useQueryClient();

    const pathname: Pathname = `/featured-opportunities/${id}`;

    return useMutation({
        mutationFn: async (userIds: ReadonlyArray<string>) => {
            const result = await cobrainerApiFetcher.postJson({
                pathname,
                payload: userIds,
            });

            if (result.isErr) {
                throw result.error;
            }
        },
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: [`${pathname}/filter`] });
        },
    });
};
